import axios from 'axios'
import pageKeys from '../common/pagekeys'
import store from '@/store'

export default {
    async getSummary() {
        try {
            const response = await axios.get(`TimeOffs/summary`, {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })            
            return response
        }catch(error){
            console.log('TimeOffs api getSummary error')
            throw error
        }
    },
    async getSummaryByTeam() {
        try {
            //if teamId=0 then company level access
            const response = await axios.get(`TimeOffs/${store.state.selectedTeamId}/summary`, {
                headers: {
                    'page_key': pageKeys.timeoff_team_approver
                }
            })            
            return response
        }catch(error){
            console.log('TimeOffs api getSummaryByTeam error')
            throw error
        }
    },
    async getSummaryByCompany() {
        try {
            //if teamId=0 then company level access
            const response = await axios.get(`TimeOffs/0/summary`, {
                headers: {
                    'page_key': pageKeys.timeoff_company_approver
                }
            })            
            return response
        }catch(error){
            console.log('TimeOffs api getSummaryByCompany error')
            throw error
        }
    },
    async getByCutoffByTeam(cutOffId) {
        try {          
            const response = await axios.get(`TimeOffs/${store.state.selectedTeamId}/cutoff/${cutOffId}`,
            {
                headers: {
                    'page_key': pageKeys.timeoff_team_approver
                }
            })                                    
            return response
        } catch (error) {
            console.log('TimeOffs api getByCutoffByTeam error')
            throw error
        }
    },
    async getByCutoffByCompany(cutOffId) {
        try {          
            const response = await axios.get(`TimeOffs/0/cutoff/${cutOffId}`,
            {
                headers: {
                    'page_key': pageKeys.timeoff_company_approver
                }
            })                                    
            return response
        } catch (error) {
            console.log('TimeOffs api getByCutoffByCompany error')
            throw error
        }
    },
    async getByCutoffByUser(cutOffId) {
        try
        {          
            //My Attendance > TimeOffs main > By Cutoff   
            const response = await axios.get(`TimeOffs/cutoff/${cutOffId}/user`, {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('TimeOff api getByCutoffByUser error')
            throw error
        }
    },
    async getByFYByUser(fiscalYear) {
        try
        {          
            //My Attendance > TimeOffs main > By Cutoff   
            const response = await axios.get(`TimeOffs/fy/${fiscalYear}/user`, {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('TimeOff api getByFYByUser error')
            throw error
        }
    },
    async getByFYByTeam(fiscalYear) {
        try
        {          
            const response = await axios.get(`TimeOffs/${store.state.selectedTeamId}/fy/${fiscalYear}`, {
                headers: {
                    'page_key': pageKeys.timeoff_team_approver
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('TimeOff api getByFYByTeam error')
            throw error
        }
    },
    async getByFYByCompany(fiscalYear) {
        try
        {          
            const response = await axios.get(`TimeOffs/0/fy/${fiscalYear}`, {
                headers: {
                    'page_key': pageKeys.timeoff_company_approver
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('TimeOff api getByFYByTeam error')
            throw error
        }
    },
    async getById(timeOffId, pageKey) {
        try {        
            const response = await axios.get(`TimeOffs/${timeOffId}`,
            {
                headers: {
                    'page_key': pageKey
                }
            })                                    
            return response
        }catch (error){
            console.log('TimeOff api getById error')
            throw error
        }
    },   
    async add(data) {
        try
        {            
            const response = await axios.post(`TimeOffs/add`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })          
            return response
        }
        catch (error)
        {
            console.log('TimeOff api add error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.post(`TimeOffs/update`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })          
            return response
        }
        catch (error)
        {
            console.log('TimeOff api update error')
            throw error
        }
    },
    async forReview(data) {
        try
        {            
            const response = await axios.post(`TimeOffs/forreview`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })          
            return response
        }
        catch (error)
        {
            console.log('TimeOff api forReview error')
            throw error
        }
    },
    async approve(data, pageKey) {
        try
        {            
            const response = await axios.post(`TimeOffs/${store.state.selectedTeamId}/approve`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })        
            return response
        }
        catch (error)
        {
            console.log('TimeOff api approve error')
            throw error
        }
    },
    async approveAll(data) {
        try
        {            
            const response = await axios.post(`TimeOffs/${store.state.selectedTeamId}/approveall`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff_team_approver
                }
            })           
            return response
        }
        catch (error)
        {
            console.log('TimeOff api approveAll error')
            throw error
        }
    },
    async forReviewAll(data) {
        try{            
            const response = await axios.post(`TimeOffs/forreviewall`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })            
            return response
        }catch (error){
            console.log('TimeOff api forReviewAll error')
            throw error
        }
    },
    async reject(data, pageKey) {
        try {            
            const response = await axios.post(`TimeOffs/${store.state.selectedTeamId}/reject`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('TimeOff api reject error')
            throw error
        }
    },
    async rejectAll(data) {
        try
        {            
            const response = await axios.post(`TimeOffs/${store.state.selectedTeamId}/rejectall`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff_team_approver
                }
            })         
            return response
        }
        catch (error)
        {
            console.log('TimeOff api rejectAll error')
            throw error
        }
    },
    async delete(data) {
        try
        {            
            const response = await axios.post(`TimeOffs/delete`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('TimeOff api delete error')
            throw error
        }
    },
    async undoDelete(data) {
        try
        {            
            const response = await axios.post(`TimeOffs/undodelete`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('TimeOff api undoDelete error')
            throw error
        }
    },
    async getByUser(transDate) {
        try
        {            
            const response = await axios.get(`TimeOffs/byuser/${transDate}`,
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })                                    
            return response
        }
        catch (error)
        {
            console.log('TimeOff api getByUser error')
            throw error
        }
    },
    async getMonthlyByUser(month) {
        try
        {            
            const response = await axios.get(`TimeOffs/byuser/monthly/${month}`,
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })                                   
            return response
        }
        catch (error)
        {
            console.log('TimeOff api getMonthlyByUser error')
            throw error
        }
    },
    async getAttachmentUrl(userId, fileName) {
        try
        {            
            const response = await axios.post(`TimeOffs/attachment/pre-signed-url`,
            {
                userId: userId,
                fileName: fileName
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('TimeOffs getAttachmentUrl api error')
            throw error
        }
    },
    async saveAttachment(data) {
        try
        {            
            const response = await axios.post(`TimeOffs/attachment/save`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('TimeOffs saveAttachment api error')
            throw error
        }
    },
    async deleteAttachment(timeOffAttachmentId) {
        try
        {            
            const response = await axios.post(`TimeOffs/attachment/delete/${timeOffAttachmentId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.timeoff
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('TimeOffs deleteAttachment api error')
            throw error
        }
    },

    // turned off
    // async getUpComing() {
    //     try
    //     {            
    //         const response = await axios.get(`TimeOffs/upcoming`,{
    //             headers: {
    //                 'page_key': pageKeys.timeoff
    //             }
    //         })                                
    //         return response
    //     }
    //     catch (error)
    //     {
    //         console.log('TimeOff api getUpComing error')
    //         throw error
    //     }
    // }
}